export default __webpack_public_path__ + "static/media/attivita-veloci.295a68ad.svg";